<template>
	<div class="new-tippy" :style="styles">
		<div class="new-tippy__element" ref="element">
			<slot name="element"></slot>
		</div>
		<div class="new-tippy__content" ref="content">
			<div class="new-tippy__head" v-if="showClose || title">
				<div class="new-tippy__title" v-if="title" v-html="title"></div>
				<i class="material-icons material-icons--small pointer new-tippy__close" @click="close()" v-if="showClose">close</i>
			</div>
			<slot name="content" :callClose="close"></slot>
		</div>
	</div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/themes/light-border.css'

export default {
	name: 'NewTippy',
	props: {
		options: {
			type: Object,
			default: () => ({
			})
		},
		title: {
			type: String,
			default: undefined,
		},
		showClose: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		instance: null,
		styles: {
		}
	}),
	emits: ['show','hide'],
	mounted() {
		const element = this.$refs.element.children[0]

		const opts = {
			allowHTML: true,
			interactive: true,
			theme: 'light-border',
			placement: 'auto',
			maxWidth: 'none',
			...this.options,
			content: this.$el.querySelector('.new-tippy__content'),
			onShow: () => {
				this.$emit('show')
			},
			onShown: () => {
				this.styles = {
					zIndex: 30,
				}
			},
			onHide: () => {
				this.styles = {}
				this.$emit('hide')
			}
		}

		this.$nextTick(() => {
			this.instance = tippy(element, opts)
		})
	},
	beforeUnmount() {
		if (this.instance) {
			this.instance.destroy()
		}
	},
	methods: {
		close() {
			if (this.instance) {
				this.instance.hide()
			}
		},
	},
	watch: {
		disabled: {
			immediate: true,
			handler(val, oldVal) {
				if (!this.instance) return
				if (val && val != oldVal) {
					this.instance.disable()
				} else if (!val && val != oldVal) {
					this.instance.enable()
				}
			},
		},
		instance: {
			once: true,
			handler(val, oldVal) {
				if (this.disabled) {
					val.disable()
				}
			}
		}
	},
}
</script>

<style scoped lang="scss">
.new-tippy {
	&__head {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 0.25rem;
	}

	&__title {
		font-size: 0.95rem;
		font-weight: 450;
		letter-spacing: 0.3px;
		// padding: 0 0 0.5rem 0;
	}

	&__content {
		padding: 0.5rem;

		.text &,
		:deep(.text) {
			display: block;
			max-height: 70vh;
			overflow-y: auto;
			text-align: justify;
		}

		:deep(.markdown) {
			display: block;
		}

	}

	&__close {
		margin-left: auto;
	}


}
</style>
